<script>
import ValidatesForm from '@/mixins/ValidatesForm'
import EmploymentCalendar from '@/api/synchronizations/EmploymentCalendar'
import OAuthProvider from '@/api/oauth/OAuthProvider'

export default {
  name: 'CalendarServiceConnector',

  mixins: [ValidatesForm],

  methods: {
    async connect(service) {
      try {
        const redirectUrl =
          window.location.origin +
          this.$router.resolve({ name: 'my-year' }).href +
          '?show-calendar-integration=true'

        const { data } = await OAuthProvider.redirect(service, {
          company_id: this.activeCompany.id,
          redirect_url: redirectUrl,
        })

        window.location = data.redirect_url
      } catch ({ response }) {
        this.validateFromResponse(response)
      }
    },

    async reconnect(calendar) {
      try {
        const redirectUrl =
          window.location.origin +
          this.$router.resolve({ name: 'my-year' }).href +
          '?show-calendar-integration=true'

        const { data } = await EmploymentCalendar.reconnect(
          calendar.external_calendar_connection,
          {
            company_id: this.activeCompany.id,
            redirect_url: redirectUrl,
          }
        )

        window.location = data.redirect_url
      } catch ({ response }) {
        this.validateFromResponse(response)
      }
    },

    async disconnect(calendar) {
      const confirm = await this.confirmCalendarDisconnect(calendar)
      if (!confirm) return

      try {
        await EmploymentCalendar.disconnect(
          this.activeEmployment,
          calendar.group,
          {
            data: {
              company_id: this.activeCompany.id,
            },
          }
        )

        this.$emit('disconnected', calendar)

        const provider = calendar.external_calendar_connection.provider

        this.success(`${provider} calendar disconnected`)
      } catch ({ response }) {
        this.validateFromResponse(response, false)
      }
    },

    async create(account) {
      try {
        await EmploymentCalendar.create(this.activeEmployment, {
          connection_id: account.id,
          company_id: this.activeCompany.id,
        })
      } catch ({ response }) {
        this.validateFromResponse(response)
      }
    },

    async confirmCalendarDisconnect(calendar) {
      if (!calendar.sync_enabled) {
        return await this.confirm(
          'Are you sure you want to disconnect? There are pending synchronisation jobs for this calendar. ' +
            'If you remove the integration now, we will not be able to sync the latest changes, ' +
            'which could result in problems such as duplicate events.',
          'Confirm delete'
        )
      }

      const provider = calendar.external_calendar_connection.provider

      return await this.confirm(
        `Are you sure you want to disconnect? Leave will be removed from the ${provider} calendar.`,
        'Confirm disconnect'
      )
    },
  },

  render() {
    return this.$scopedSlots.default({
      connect: this.connect,
      reconnect: this.reconnect,
      disconnect: this.disconnect,
      create: this.create,
    })
  },
}
</script>
